// extracted by mini-css-extract-plugin
module.exports = {"container":"KKqQ0NbW6wo137a0t6Ww","leftSide":"D70qiWEwlTcY5W4iZlwY","rightSide":"fK0LUzP319Lm3xRTLk6n","haveAccount":"xaZcunInO_UNOqTmoCOG"};